module.exports = __webpack_public_path__ + "components/outside-promo-page/static/surf-forecast__icon-3127ebff76f2b72a8ce64fd786c0a51f.svg";